<template>
<div class="chapter">
<div class="inner_page">
<p class="centerf"><a id="page_5"></a><strong><span class="small">TABLE OF</span></strong></p>
<p class="image"><img alt="Images" src="images/common.jpg" width="81"/></p>
<p class="chap-c" id="contents"><span class="orange">CONTENTS</span></p>
<p class="tocb"><a href="#/xhtml/intro#intro">INTRODUCTION</a></p>
<p class="image"><img alt="Images" src="images/line1.jpg" width="400"/></p>
<p class="toca"><a href="#/xhtml/part01#part01"><em><span class="orange">PART ONE</span></em><br/>THE HISTORY OF OUR TASTE FOR MAPLE SYRUP</a></p>
<p class="toc"><span href="#/xhtml/part02#part02" title="Link target outside of Sample"><em><span class="orange">PART TWO</span></em><br/>THE SCIENCE OF GROWING, TAPPING, AND EVAPORATING SAP INTO SYRUP</span></p>
<p class="toc"><span href="#/xhtml/part03#part03" title="Link target outside of Sample"><em><span class="orange">PART THREE</span></em><br/>COOKING WITH MAPLE SYRUP</span></p>
<p class="tocb"><img alt="Images" src="images/line1.jpg" width="400"/></p>
<p class="tocs"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="tocs"><span href="#/xhtml/author#author" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
<p class="tocs"><span href="#/xhtml/works#works" title="Link target outside of Sample">WORKS CONSULTED</span></p>
<p class="tocsb"><span href="#/xhtml/index#index" title="Link target outside of Sample">INDEX OF SEARCHABLE TERMS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3cbfeb19